module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume_pc/icon_scout-9e12ab8003d9697936bcdb3300788dfb.png";